import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setQuarter } from "redux/KPIs/filterSlice";
import Goals from "components/KPIs/tabs/goals";
import toast, { Toaster } from "react-hot-toast";
import 'assets/scss/kpi.scss';
import { People } from "components/KPIs/tabs/individuals/individuals";
import { getQuarters } from "components/Apis/KPIs";
import { fetchQuartersB085 } from "components/Apis/KPIs";
import { fetchPeople } from "redux/KPIs/peopleSlice";
import { Company } from "components/KPIs/tabs/company";
import CenteredMessage from "components/UI/CenteredMessage";
import ContinuousImprovement from "components/KPIs/tabs/continuousImprovment";
import BonusSuccessCriteriaTab from "components/KPIs/tabs/bonusSuccessCriteria";
import KPIBonusCalculator from "components/KPIs/tabs/bonusCalculator";
import { getKPIBonusCalculations } from "components/Apis/KPIs";
import LoadingAnimation from "components/UI/Loader";

export const NoTeamLabel = "Expedite";

const KPIs = () => {
    const [KPIBonusGroupAccess, setBonusGroupAccess] = useState(false);
    const [quarterDataScraped, setQuarterDataScraped] = useState("loading");
    const quarter = useSelector((state) => state.KPIFilterReducer.quarter);

    const tabs = [
        { name: "Individuals", component: <People /> },
        { name: "Goals", component: <Goals /> },
        { name: "Company", component: <Company /> },
        { name: "Continuous Improvement Projects", component: <ContinuousImprovement /> }
    ];

    const lockedTabs = [
        { name: "Bonus Success Criteria", component: <BonusSuccessCriteriaTab /> },
        { name: "Bonus Calculator", component: <KPIBonusCalculator /> }
    ];

    const monthQuarterKey = {
        Q1: ["January", "February", "March"],
        Q2: ["April", "May", "June"],
        Q3: ["July", "August", "September"],
        Q4: ["October", "November", "December"],
    }
    const [monthOptions, setMonthOptions] = useState(monthQuarterKey[quarter.quarter]);

    const [tab, setTab] = useState(tabs[0]); // Default to the first tab
    const dispatch = useDispatch();

    const currentYear = new Date().getFullYear();
    const pastTwoYears = [currentYear - 3, currentYear - 2, currentYear - 1, currentYear].reverse();

    const handleYearChange = (event) => {
        if (event.target.value != quarter.year) {
            const selectedYear = event.target.value;
            dispatch(setQuarter({
                ...quarter,
                year: selectedYear,
            }));
        }
    };

    const handleQuarterChange = (event) => {
        if (event.target.value != quarter.quarter) {
            const selectedQuarter = event.target.value;
            dispatch(setQuarter({
                ...quarter,
                quarter: selectedQuarter,
                month: 'None',
            }));
            setMonthOptions(monthQuarterKey[selectedQuarter]);
        }
    };

    const handleMonthChange = (event) => {
        if (event.target.value != quarter.month) {
            const selectedMonth = event.target.value;
            dispatch(setQuarter({
                ...quarter,
                month: selectedMonth,
            }));
        }
    }

    async function doesQuarterExist(quarter) {
        const itDoes = await getQuarters(quarter);
        setQuarterDataScraped(itDoes);

        if (itDoes === "loading") {
            setTimeout(() => {
                // Recursively call the function after a delay if status is still "loading"
                doesQuarterExist(quarter);
            }, 2000);
        }

        else if (itDoes === "failed") {
            toast.error(
                "Last scraper action failed!"
            )
        }

        else if (itDoes) {
            setTimeout(() => {
                dispatch(fetchPeople(quarter));
            }, 500);
        }
    }

    useEffect(() => {
        if (quarter) {
            (async () => {
                try {
                    const response = await getKPIBonusCalculations(quarter);
                    setBonusGroupAccess(true);
                }
                catch (error) {
                    if (error.response.status === 403) {
                        // user doesnt have access to kpi bonus
                    }
                    else {
                        toast.error(error.response.data);
                    }
                }
            })();
        }
    }, [quarter]);

    useEffect(() => {
        doesQuarterExist(quarter);
    }, [quarter.month, quarter.year, quarter.quarter]);


    return (
        <>
            {/* Tabs Section */}
            <Toaster position='bottom-right' />
            <div className="row warehouse-main-section-buttons-wrapper">
                <div className="col">
                    {tabs.map((ttab) => (
                        <button
                            key={ttab.name}
                            onClick={() => setTab(ttab)}
                            className={`warehouse-main-header ${tab.name === ttab.name ? "warehouse-active" : ""}`}
                        >
                            {ttab.name}
                        </button>
                    ))}
                    {KPIBonusGroupAccess &&
                        (
                            <>
                                {lockedTabs.map((ttab) => (
                                    <button
                                        key={ttab.name}
                                        onClick={() => setTab(ttab)}
                                        className={`warehouse-main-header ${tab.name === ttab.name ? "warehouse-active" : ""}`}
                                    >
                                        {ttab.name}
                                    </button>
                                ))}
                            </>
                        )
                    }

                </div>
            </div>

            {/* Control Panel */}
            <div className="section-control-panel row">
                <header className="col-auto">
                    {tab.name}
                </header>
                <div style={{ flexDirection: 'row' }} className="col justify-content-end form-group pr-0 mb-2 mt-2">
                    <div className="d-flex flex justify-content-between mr-3">
                        <label>B085 Status:</label>
                        <button
                            className={`form-control header-btn ${quarterDataScraped ? "" : "unfetched"}`}
                            onClick={() => {
                                if (!(quarterDataScraped === "loading")) {
                                    fetchQuartersB085(quarter)
                                        .then(() => {
                                            doesQuarterExist(quarter);
                                        })
                                }
                            }}
                            disabled={quarterDataScraped === "loading"}
                        >
                            {quarterDataScraped === "loading" ? (
                                <span className="d-flex align-items-center">
                                    <i class="mr-2 fas fa-sync fa-spin"></i><>Scraper Working</>
                                </span>
                            ) : quarterDataScraped ? (
                                <span className="d-flex align-items-center">
                                    <i className="mr-2 fa fa-sync"></i><>Resync with Sylectus</>
                                </span>
                            ) : (
                                <span className="d-flex align-items-center">
                                    <i className="mr-2 fa fa-search"></i><>Fetch Sylectus Report</>
                                </span>
                            )}
                        </button>
                    </div>
                    <div className="d-flex justify-content-between mr-3">
                        <label>Year:</label>
                        <select
                            className="form-control"
                            defaultValue={quarter.year}
                            onChange={handleYearChange}
                        >
                            {pastTwoYears.map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="d-flex justify-content-between mr-3">
                        <label>Quarter:</label>
                        <select
                            className="form-control"
                            defaultValue={quarter.quarter}
                            onChange={handleQuarterChange}
                        >
                            {['Q1', 'Q2', 'Q3', 'Q4'].map((quarterOption) => (
                                <option key={quarterOption} value={quarterOption}>
                                    {quarterOption}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="d-flex justify-content-between">
                        <label>Month:</label>
                        <select
                            className="form-control"
                            defaultValue={quarter.month}
                            onChange={handleMonthChange}
                        >
                            <option value={'None'}>---</option>
                            {monthOptions.map((monthOption) => (
                                <option key={monthOption} value={monthOption} >
                                    {monthOption}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            {(!quarterDataScraped)
                ? (
                    <CenteredMessage
                        heading="Quarter not scraped!"
                        message="Please fetch the Sylectus report to load data."
                    />
                ) : (quarterDataScraped === "loading")
                    ? (
                        <>
                            <CenteredMessage
                                heading="Scraping..."
                                message="Please wait while the data is being fetched."
                            />
                            <br />
                            <div className="d-flex justify-content-center align-items-center mt-4">
                                <LoadingAnimation />
                            </div>
                        </>
                    ) : (
                        <div className="driver-reservations-content">
                            <div className="horizontal-scroll-conent-wrapper">
                                {tab.component}
                            </div>
                        </div>
                    )}
        </>
    );
};

export default KPIs;